import axios from 'axios';

export default {
    findTemplate() {
        const token = localStorage.getItem('token'); 
        return axios({
            method: 'get',
            url: process.env.VUE_APP_BASE_URL_CORE + 'auth/organization/template',
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateTemplate(organizationTemplateRequest) {
        const token = localStorage.getItem('token');

        return axios({
            method: 'put',
            url: process.env.VUE_APP_BASE_URL_CORE + 'auth/organization/template',
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
            data: organizationTemplateRequest,
        });
    },
    findQuestionaryAnswer(patientId) {
        const token = localStorage.getItem('token'); 
        return axios({
            method: 'get',
            url: process.env.VUE_APP_BASE_URL_CORE + 'auth/organization/template/patient/' + patientId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveQuestionaryAnswer(patientId, data) {
        const token = localStorage.getItem('token');

        return axios({
            method: 'post',
            url: process.env.VUE_APP_BASE_URL_CORE + 'auth/organization/template/patient/' + patientId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
            data: data,
        });
    },
};